export const ATTR_DISABLED = 'disabled';
